import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, ActionSheetController, AlertController, ToastController, ModalController } from 'ionic-angular';
import { DIC } from '../dic';
// import { HomePage } from '../home/home';
import { GN } from '../../gn';
import { FpassPage } from './fpass';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { GlhomePage } from '../gps-link/glhome/glhome';
import { PinemployeehomePage } from '../pinemployeehome/pinemployeehome';
import * as moment from 'moment';
import { NopayalarmPage } from '../nopayalarm/nopayalarm';

/**
 * Generated class for the LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage({
  name: 'login'
})

@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {
  @ViewChild('myPassInput') myPassInput;
  @ViewChild('myPassInput') myPassInput1;
  @ViewChild('myPassInput') myPassInput2;
  myEmail: any = ''
  myPass: any = ''
  myPass1: any = ''
  myPass2: any = ''
  myPassWW: any = '';
  myPassWW1: any = '';
  myPassWW2: any = '';
  myToast: any
  fromindoor = false
  userind = -1

  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public actionSheetCtrl: ActionSheetController, public gn: GN, public alertCtrl: AlertController, public toastCtrl: ToastController, public modalCtrl: ModalController) {
    if (navParams.get('indoor') != undefined) {
      this.fromindoor = navParams.get('indoor');
      console.log(this.fromindoor, 'this.fromindoor')
    }
    if (navParams.get('userindoor') != undefined) {
      this.userind = navParams.get('userindoor');
    }
    console.log('Resset Pass=' + this.gn.resetPassUser)
    // console.log(this.userind, 'this.userind')

  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad LoginPage');
    if (this.fromindoor == true) {
      this.loadIndoor()
    }

  }

  loadIndoor() {
    var _that = this
    this.gn._Post('/api/gn/authindoor', { userid: this.gn.crypt(this.userind) }, function (_data) {
      _that.myEmail = _data.username
      _that.myPass = _data.password
      _that.gotoHome()
    })
  }


  chooseLanguge() {
    var _that = this
    let actionSheet = this.actionSheetCtrl.create({
      title: this.dic.l["chooselang"],
      buttons: [
        {
          text: 'Македонски',
          handler: () => {
            _that.dic.changeLanguage('mk')
          }
        }, {
          text: 'English',
          handler: () => {
            _that.dic.changeLanguage('en')
          }
        }, {
          text: 'Shqiptare',
          handler: () => {
            _that.dic.changeLanguage('sq')
          }
        }, {
          text: 'Српски',
          handler: () => {
            _that.dic.changeLanguage('srb')
          }
        }
      ]
    });
    actionSheet.present();
  }


  gotoHome() {
    // this.navCtrl.setRoot(HomePage)
    if (this.myToast != null) {
      return
    }


    var _that = this
    if (this.myEmail == "") {
      let alert = this.alertCtrl.create({ title: _that.dic.l["error"], subTitle: _that.dic.l["enteremail"], buttons: [_that.dic.l['ok']] });
      alert.present();

    } else {
      if (this.myPass == "") {
        let alert = _that.alertCtrl.create({ title: _that.dic.l["error"], subTitle: _that.dic.l["enterpass"], buttons: [_that.dic.l['ok']] });
        alert.present();

      } else {
        _that.myToast = _that.toastCtrl.create({
          message: _that.dic.l["wait"],
          position: 'top'
        });
        _that.myToast.present();
        this.gn._Post('/api/gn/auth', { A: this.gn.crypt(this.myEmail), B: this.gn.crypt(this.myPass) }, function (_data) {
          // console.log(_data, 'daj da ja vidam prvata data')
          if (_data.C == 1 && _data.Cact == 1) {
            _that.gn._Post('/api/gn/auth2', { D: _that.gn.crypt(_that.myEmail), E: _that.gn.crypt(_that.myPass) }, function (_data2) {
              // console.log(_data2, 'daj da ja vidam vtorata data2')
              // console.log(_data2.F)

              // if (_data2.D != -1 && document.getElementById('login-grid-mob').offsetHeight == 0) {
              //   let alert = _that.alertCtrl.create({ title: _that.dic.l["error"], subTitle: _that.dic.l["driverDesktop"], buttons: [_that.dic.l['ok']] });
              //   alert.present();
              //   _that.myToast.dismiss()
              //   _that.myToast = null
              // } else {
              localStorage.setItem("PANQAWSEDRF", _that.gn.crypt(_data2.F))
              localStorage.setItem("gn-asd-poi", _that.gn.oldcrypt(_data2.F))

              //localStorage.setItem("UPDATE-PANPASS", _that.gn.crypt(_data2.L))
              localStorage.setItem("UPDATE-PANPASS", moment(_data2.L).format('YYYY-MM-DD HH:mm:ss'))
              localStorage.setItem("CHECK-PANPASS", moment().format('YYYY-MM-DD HH:mm:ss'))

              localStorage.setItem("login-dt", moment().format('YYYY-MM-DD HH:mm:ss'))

              //
              _that.gn.checkUserHash(function () {

                _that.myToast.dismiss()
                _that.myToast = null
                // console.log(_that.gn.user)
                if (_that.gn.isGPSLINK == true) {
                  _that.navCtrl.setRoot(GlhomePage)
                } else {
                  if (document.getElementById('login-grid-mob').offsetHeight > 0) {
                    //mebelvi salon
                    if (_that.gn.getPriv('livetracking') == 1 || (_that.gn.user.UserId + '' == '2817' || _that.gn.user.UserId + '' == '2818')) {
                      //if (_that.gn.getPriv('livetracking') == 1) {
                      // _that.navCtrl.setRoot(HomePage)
                      // _that.rootPage = 'home'
                      // _that.navCtrl.setRoot(HomePage)
                      _that.navCtrl.setRoot('home')
                    } else {

                      let toast = _that.toastCtrl.create({ message: _that.dic.l["noacespriv"], duration: 3000, position: 'top' });
                      toast.present();
                      _that.navCtrl.setRoot(LoginPage)

                      console.log('vlagas vo else')
                      // }

                    }

                  } else {
                    // _that.navCtrl.setRoot(HomePage)
                    _that.navCtrl.setRoot('home')
                  }

                }
                _that.gn.addLog(1, '');
              })
              //}
            })
          } else {
            if (_data.C == 0) {
              let alert = _that.alertCtrl.create({ title: _that.dic.l["error"], subTitle: _that.dic.l["wrongcred"], buttons: [_that.dic.l['ok']] });
              alert.present();
              _that.myToast.dismiss()
              _that.myToast = null
            } else {
              //alarm za neplateni smetki
              if (_data.Cnopay == 1) {
                _that.myToast.dismiss()
                _that.myToast = null
                let modal = _that.modalCtrl.create(NopayalarmPage, {
                  suspend: 1, cb: function () {
                  }
                },
                  { cssClass: "modal-wellcomemessage" }
                );
                modal.present();
              } else {
                let alert = _that.alertCtrl.create({ title: _that.dic.l["error"], subTitle: _that.dic.l["userdeactivated"], buttons: [_that.dic.l['ok']] });
                alert.present();
                _that.myToast.dismiss()
                _that.myToast = null
              }
              //end alarm za neplateni smetki

              // let alert = _that.alertCtrl.create({ title: _that.dic.l["error"], subTitle: _that.dic.l["userdeactivated"], buttons: [_that.dic.l['ok']] });
              // alert.present();
              // _that.myToast.dismiss()
              // _that.myToast = null
            }
          }
        })
      }
    }
  }


  forgotpassword() {
    //this.navCtrl.setRoot('fpass')
    // this.navCtrl.setRoot(FpassPage)
  }

  handleLogin() {
    if (this.myPass == '') {
      this.myPass = this.myPassWW;
    }
    this.gotoHome()
  }

  onKeydown() {
    this.myPassInput.setFocus();



  }

  changePass() {
    this.myPassWW = this.myPass;
  }
  changePass1() {
    this.myPassWW1 = this.myPass1;
  }
  changePass2() {
    this.myPassWW2 = this.myPass2;
  }
  handleLogin1() {
    this.saveResetPass()
  }

  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  saveResetPass() {
    var _that = this
    if (this.myPass1 == '') {
      let toast = this.toastCtrl.create({ message: this.dic.l["enterpass"], duration: 3000, position: 'top' });
      toast.present();
      return false;
    } else {
      if (this.myPass2 == '') {
        let toast = this.toastCtrl.create({ message: this.dic.l["enterrepass"], duration: 3000, position: 'top' });
        toast.present();
        return false;
      } else {
        var i = /^(?=.*[@$!%*#?&])/;
        var re = /^(?=.*[A-Z])/;
        if (this.myPass1.length < 6) {
          let toast = this.toastCtrl.create({ message: this.dic.l["enterpasswordsixch"], duration: 3000, position: 'top' });
          toast.present();
          return false;
        }
        if (this.myPass2.length < 6) {
          let toast = this.toastCtrl.create({ message: 'RE ' + this.dic.l["enterpasswordsixch"], duration: 3000, position: 'top' });
          toast.present();
          return false;
        }
        if (!i.test(this.myPass1)) {
          let toast = this.toastCtrl.create({ message: this.dic.l["enterpasswordspecch"], duration: 3000, position: 'top' });
          toast.present();
          return false;
        }
        if (!i.test(this.myPass2)) {
          let toast = this.toastCtrl.create({ message: 'RE ' + this.dic.l["enterpasswordspecch"], duration: 3000, position: 'top' });
          toast.present();
          return false;
        }
        if (!re.test(this.myPass1)) {
          let toast = this.toastCtrl.create({ message: this.dic.l["enterpasswordupper"], duration: 3000, position: 'top' });
          toast.present();
          return false;
        }
        if (!re.test(this.myPass2)) {
          let toast = this.toastCtrl.create({ message: 'RE ' + this.dic.l["enterpasswordupper"], duration: 3000, position: 'top' });
          toast.present();
          return false;
        }
        if (this.myPass1 != this.myPass2) {
          let toast = this.toastCtrl.create({ message: this.dic.l["usinfo04"], duration: 3000, position: 'top' });
          toast.present();
          return
        }
        var _dat = {
          user: this.gn.crypt(this.gn.resetPassUser),
          pass: this.gn.crypt(this.myPass1),

        }
        //this.gn.disableBtn();
        this.gn.tfBtn = true;
        this.gn._Post('/api/gn/resetpassuser', _dat, function (_data) {
          _that.myEmail = _that.gn.resetPassUser
          _that.myPass = _that.myPass1
          _that.myPass1 = ''
          _that.myPass2 = ''
          _that.gn.tfBtn = false;
          _that.handleLogin();
          _that.gn.resetPassUser = ''
        })
      }
    }
  }



}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts